<template>
    <b-container fluid class="p-3">
        <b-row class="no-gutters mb-4">
            <b-col md="6">
                <p>
                    Please map the following Lodgix invoice line items to the appropriate revenue and current liability
                    accounts
                    within QuickBooks Online:
                </p>
                <div class="d-flex flex-column">
                    <div v-for="item in accountMapping" :key="item.id" class="mb-2">
                        <form-select class="mb-0" v-model="item.quickbooks_account_id" :floatingLabel="item.name"
                            :options="accountChoicesOptions" @change="value => onChangeMapping(item.id, value)" />
                        <small v-if="item.name === 'Other Deposits'">
                            (Must be mapped to a current liability account)
                        </small>
                        <small v-if="item.name === 'Payments'">
                            (QB default is Undeposited Funds account, please consult bookkeeper before changing)
                        </small>
                    </div>


                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { mapGetters } from 'vuex';
import formSelect from '../generic/form-select/form-select.vue';
import api from '../../api';
import { QUICKBOOKS_ENDPOINT_OLD } from '../../endpoints';
export default {
    name: 'AccountMapping',
    components: {
        formSelect,
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('quickbooksOld', ['accountMapping', 'accountChoices']),
        accountChoicesOptions() {
            return [{ value: null, text: 'Undefined' }, ...this.accountChoices.map((choice) => {
                const text = choice.account_number ? `${choice.account_number} - ${choice.name}` : choice.name;
                return {
                    value: choice.id,
                    text,
                };
            })]
        }
    },
    methods: {
        async onChangeMapping(id, value) {
            try {
                await api.post(QUICKBOOKS_ENDPOINT_OLD(id) + 'save-account-mapping/', { value })
            } catch (e) {
                this.errorToast({ text: 'Could not update account mapping' });
            }
        }
    },
};
</script>

<style scoped>
/* Your component styles here */
</style>
